import styled from 'styled-components'

export const Fieldset = styled.fieldset`
    border-radius: 4px;
`
